/* Ported from panel.davakhoone.com (TipTap 3 / Vue 3) to TipTap 2 / Vue 2 for sakhtineo. */
import { Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import HtmlBlockView from '@/views/includes/HtmlBlockView.vue'

function encodeHtmlAttr(html) {
  return encodeURIComponent(String(html || ''))
}

function decodeHtmlAttr(value) {
  if (value == null || value === '') return ''
  try {
    return decodeURIComponent(value)
  } catch (_) {
    return String(value)
  }
}

/** Convert empty html-block wrappers (data-html attr) into real inner HTML for save/source */
export function materializeHtmlBlocks(html) {
  if (!html || typeof document === 'undefined') return html || ''

  const wrap = document.createElement('div')
  wrap.innerHTML = html

  wrap.querySelectorAll('div[data-type="html-block"]').forEach((el) => {
    const attr = el.getAttribute('data-html')
    const raw = attr != null ? decodeHtmlAttr(attr) : el.innerHTML
    el.innerHTML = raw
    el.removeAttribute('data-html')
  })

  return wrap.innerHTML
}

export const HtmlBlock = Node.create({
  name: 'htmlBlock',

  group: 'block',

  atom: true,

  draggable: true,

  selectable: true,

  defining: true,

  addAttributes() {
    return {
      html: {
        default: '',
        parseHTML: (element) => {
          const attr = element.getAttribute('data-html')
          if (attr != null && attr !== '') return decodeHtmlAttr(attr)
          return element.innerHTML || ''
        },
        renderHTML: () => ({})
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="html-block"]',
        getAttrs: (element) => {
          const attr = element.getAttribute('data-html')
          if (attr != null && attr !== '') {
            return { html: decodeHtmlAttr(attr) }
          }
          return { html: element.innerHTML || '' }
        }
      }
    ]
  },

  renderHTML({ node }) {
    return [
      'div',
      {
        'data-type': 'html-block',
        class: 'tiptap-html-block',
        'data-html': encodeHtmlAttr(node.attrs.html || '')
      }
    ]
  },

  addNodeView() {
    return VueNodeViewRenderer(HtmlBlockView)
  },

  addCommands() {
    return {
      insertHtmlBlock:
        (html = '<div>\n  \n</div>') =>
        ({ commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: { html }
          })
    }
  }
})
